import React from 'react'
import type { InfiniteData, QueryObserverResult } from '@tanstack/react-query'
import { SharedBetCard } from '@core/Areas/FollowMe/Components/Common/SharedBetCard'
import { SkeletonLoader } from '@core/Areas/FollowMe/Components/Common/SkeletonLoader'
import { FeedContainerStyled } from '@core/Areas/FollowMe/Components/Common/FollowMe.styles'
import { PullToRefreshContainer } from '@mobi/component-library/Common/PullToRefreshContainer'
import { FollowMeSharedBet } from '@core/Areas/FollowMe/types'
import { EmptyTipsMessage } from '../../../EmptyTipsMessage'
import { IncomingBetNotificationManager } from './Components/IncomingBetNotificationManager'

export const PendingTips: React.FC<{
  isLoading: boolean
  LoadMoreButton: () => React.JSX.Element | null
  data: InfiniteData<FollowMeSharedBet[], unknown> | undefined
  refetch: () => Promise<QueryObserverResult<InfiniteData<FollowMeSharedBet[], unknown>>>
}> = ({ data, isLoading, refetch, LoadMoreButton }) => {
  const [incomingPostId, setIncomingPostId] = React.useState<string | null>(null)

  if (isLoading) return <SkeletonLoader />

  const pendingBets = data?.pages.flat().filter(bet => bet.postId.toString() !== incomingPostId)

  if (!pendingBets || pendingBets.length === 0) return <EmptyTipsMessage />

  return (
    <PullToRefreshContainer onRefresh={refetch}>
      <FeedContainerStyled>
        <IncomingBetNotificationManager onIncomingPostId={setIncomingPostId} />

        {pendingBets.map(sharedBet => (
          <SharedBetCard
            key={`${sharedBet.postId}.${sharedBet.ownerAccountId}`}
            sharedBet={sharedBet}
          />
        ))}

        <LoadMoreButton />
      </FeedContainerStyled>
    </PullToRefreshContainer>
  )
}
